import { Component } from '@angular/core';
import { MatSelectChange , MatSelectModule} from '@angular/material/select';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {

  constructor(public authService: AuthService) { }

  public selectedBranch = '';
  branchControl = new FormControl();
  branches = [
    'Sucursal 1',
    'Sucursal 2',
    'Sucursal 3',
    'Sucursal 4',
    'Sucursal 5'
  ];

  ngOnDestroy(): void {
    // Realiza tareas de limpieza aquí, como cancelar suscripciones a observables
  }

  logout(){
    this.authService.logout();
  }
}
